module.exports = __webpack_public_path__ + "media/images/river/shirt-carousel/shirt-7-4e088cafe7e8d421bc276047ba7cb23c.jpg";